import z from 'zod';

export const MarketCodeSchema = z.enum(['AT', 'CZ', 'DE', 'PL']);
export type MarketCode = z.infer<typeof MarketCodeSchema>;

export const CurrencyCodeSchema = z.enum(['CZK', 'EUR', 'PLN']);
export type CurrencyCode = z.infer<typeof CurrencyCodeSchema>;

export const SupportedTimezonesSchema = z.enum(['Europe/Berlin', 'Europe/Prague', 'Europe/Vienna', 'Europe/Warsaw']);
export type SupportedTimezones = z.infer<typeof SupportedTimezonesSchema>;

export const MARKET_CODE_TO_CURRENCY_CODE_MAP = {
    AT: 'EUR',
    CZ: 'CZK',
    DE: 'EUR',
    PL: 'PLN',
} as const satisfies Record<MarketCode, CurrencyCode>;

export const CURRENCY_CODE_TO_DECIMALS_MAP = {
    CZK: 2,
    EUR: 2,
    PLN: 2,
} as const satisfies Record<CurrencyCode, number>;

export const MARKET_CODE_TO_TIMEZONE_MAP = {
    AT: 'Europe/Vienna',
    CZ: 'Europe/Prague',
    DE: 'Europe/Berlin',
    PL: 'Europe/Warsaw',
} as const satisfies Record<MarketCode, SupportedTimezones>;
